import type { LoginOptions } from "@xfinity-web/oauthjs";
import { envConfig } from "./envConfigs";

export const oauthConfig: LoginOptions = {
  allowIframeLoginWithoutPromptNone: false,
  authOpts: {
    redirect_uri: "/support/storeappointmentplt/customer/",
    scope: "urn:convoy:security:token:client-credentials urn:convoy:user#read urn:csp:scope:self-help:user:me",
  },
  authorizeUrl: "https://oauth.xfinity.com/oauth/authorize",
  iframeRedirectUri: "/support/storeappointmentplt/token.html",
  redirect: true,
  useIframe: false,
  ...envConfig.oauthConfig,
};
